import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=f7b97c8a&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&lang=ts"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=f7b97c8a&prod&lang=scss"
import style1 from "./InfoBlock.vue?vue&type=style&index=1&id=f7b97c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b97c8a",
  null
  
)

export default component.exports